// Importing all the required class
import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import MoveMoneyConstants from '../constants/MoveMoneyConstants';
import MoveMoneyApiUtils from '../utils/MoveMoneyApiUtils';
import AccountsStore from './AccountsStore';
import MoveMoneyPayeeStore from './MoveMoneyPayeeStore';
import { CHANGE_EVENT } from '../constants/AppConstants';
import AppConstants from '../constants/AppConstants';
import _ from 'lodash';
import StringConstant from '../constants/StringConstants';
import moment from 'moment';
// Declaring Variables
const NotInPot = 'Not in Pot';
let enableToAccountList = true;
let enablePayeeList = true;
let backURL = undefined;
let _fromAmount = 0;
let _selectedAccount = StringConstant.EmptyString;
let _toSelectedAccount = StringConstant.EmptyString;
let _selectedPayee = StringConstant.EmptyString;
let _nextStep = StringConstant.From;
let _selectedPot = StringConstant.EmptyString;
let _selectedToPot = StringConstant.EmptyString;
let _tempSelectedPot = StringConstant.EmptyString;
let _tempSelectedToPot = StringConstant.EmptyString;
let _isPotClick = false;
let _isSavingsPotToClicked = false;
let _isSavingsPotFromClicked = false;
let _selectedPotAccountID;
let _selectedToPotAccountID;
let _isTransfer = false;
let _isSavingTotClicked = false;
let _fromSavingOpened = { id: '' };
let _toSavingOpened = { id: '' };
let _accountDetails = [];
let accountList = [];
let _potDetails = [];
let _payeeList = [];
// todo global variable manipulation going on here!
let _accounts = []; // eslint-disable-line
let _accountDetailIterator = 0; // eslint-disable-line
let _successIterator = 0; // eslint-disable-line
let _moveMoney = StringConstant.EmptyString;
let _spendingData = StringConstant.EmptyString;
let isFromSpending = false;
let _isToSavingTotClicked = false;
let _toCredit = false;
let payeeListError = '';
let _endingDetails = {
  dtStart: StringConstant.chooseDate,
  dtEndText: StringConstant.chooseDate,
  oftenText: StringConstant.pleaseSelect,
  stopitwhenText: StringConstant.whenicancel,
  when: moment(),
  end: StringConstant.whenCancelText,
  isRepeat: false,
  endingText: StringConstant.EmptyString,
  reference: StringConstant.EmptyString,
  amount: StringConstant.EmptyString,
  endDate: StringConstant.chooseDate,
  isOneOff: true,
  isPickDateClicked: false,
  isNoOfTimesClicked: false,
  isWhenICancelClicked: true,
  noOfTimesFlag: false,
  pickDateFlag: false,
  isRegular: false,
};
let _repeatData = {
  futureDate: moment(),
  reference: null,
  oneOffPayment: true,
  amount: '',
};
let _response = null;
let _resetToOneOff = false;
let _isParentClick = {
  status: false,
  type: '',
};
let isUpdateBalance = false;
let enableFromContinue = false;
let enableToContinue = false;

// @Pravin : It Will get changed
let _selecctedPotOfFromAccount = {};
let _selectedFromAccount = {};

let _selecctedPotOfToAccount = {};
let _selectedToAccount = {};
let _inReview = false;
let _displayManagePayeePage = false;
export const getPayee = (payees, accountNumber, sortCode) => {
  if (_.get(payees, 'beneficiaries')) {
    return _.find(payees.beneficiaries, ({ to_account }) => {
      const { account_number, sort_code } = to_account;
      return account_number === accountNumber && sort_code === sortCode;
    });
  }
};
class MoveMoneyStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }

  getFromAccounts() {
    // SAVING_TOT_CLICKED
    return accountList;
  }
  getFromAccountsFromAccountsStore() {
    const fromAccountList = AccountsStore.getAccounts();
    const _fromTotalAccountList = [];

    // const _fromAccountList = { accounts: [] };
    if (fromAccountList === undefined) {
      return _fromTotalAccountList;
    }
    if (
      (this.isOneOffPayment() || !_.isEmpty(this.isOnlyMoveMoney())) &&
      !this.getOneOffPayment().isMonthly
    ) {
      fromAccountList.map((account) => {
        if (
          account.actionsAvailable['/account/payments/transfer/out'] === true
        ) {
          _fromTotalAccountList.push(account);
        }
        return false;
      });

      return _fromTotalAccountList;
    } else if (this.isOneOffPayment() && this.getOneOffPayment().isMonthly) {
      fromAccountList.map((account) => {
        if (
          account.actionsAvailable['/account/payments/transfer/out'] === true &&
          this.getSelectedToAccount().id !== account.id &&
          account.actionsAvailable['/account/mandates/so/write'] === true
        ) {
          _fromTotalAccountList.push(account);
        }
        return false;
      });
      return _fromTotalAccountList;
    } else {
      fromAccountList.map((account) => {
        if (
          account.actionsAvailable['/account/payments/uk/default/out'] ===
            true ||
          account.actionsAvailable['/account/payments/transfer/out'] === true
        ) {
          _fromTotalAccountList.push(account);
        }
        return false;
      });
      return _fromTotalAccountList;
    }
  }
  spendingFromList() {
    const fromAccountList = AccountsStore.getAccounts();
    const _fromTotalAccountList = [];
    if (fromAccountList === undefined) {
      return _fromTotalAccountList;
    }

    fromAccountList.map((account) => {
      if (account.actionsAvailable['/account/payments/transfer/out'] === true) {
        _fromTotalAccountList.push(account);
      }
      return false;
    });
    return _fromTotalAccountList;
  }
  setRegularAmount(_spendingData) {
    _repeatData.amount = _spendingData.amt2;
  }
  resetRepeatData() {
    _repeatData = {
      futureDate: moment(),
      reference: null,
      oneOffPayment: true,
      amount: '',
    };
  }
  setRepeatData(repeatData) {
    _repeatData = repeatData;
  }
  getRepeatData() {
    return _repeatData;
  }
  AddPayeeFromList() {
    const fromAccountList = AccountsStore.getAccounts();
    const _fromTotalAccountList = [];
    if (fromAccountList === undefined) {
      return _fromTotalAccountList;
    }

    fromAccountList.map((account) => {
      if (
        account.actionsAvailable['/account/payments/uk/default/out'] === true
      ) {
        _fromTotalAccountList.push(account);
      }
      return false;
    });
    return _fromTotalAccountList;
  }
  getToAccountsFromAccountsStore() {
    const toAccountList = AccountsStore.getAccounts();
    const _toTotalAccountList = [];
    if (toAccountList === undefined) {
      return _toTotalAccountList;
    }

    toAccountList.map((account) => {
      if (account.actionsAvailable['/account/payments/transfer/in'] === true) {
        if (
          (!this.IsAccountSame(account.id) && account.type !== 'savings') ||
          (account.type === 'savings' && !this.isSavingTotClicked()) ||
          (account.type === 'savings' &&
            this.isSavingTotClicked() &&
            !this.IsAccountSame(account.id))
        ) {
          _toTotalAccountList.push(account);
        }
      }
      return false;
    });

    return _toTotalAccountList;
  }
  getPotDetails(id) {
    return _.find(_potDetails, { id });
  }

  getAllPayees() {
    if (_payeeList !== undefined && _payeeList.beneficiaries !== undefined) {
      const sortPayees = _.sortBy(_payeeList.beneficiaries, (beneficiary) =>
        beneficiary.display_name.toLowerCase() === ''
          ? beneficiary.to_account.name.toLowerCase()
          : beneficiary.display_name.toLowerCase()
      );
      return { beneficiaries: sortPayees };
    }
    return _payeeList;
  }

  getAllSavedPayees() {
    if (_payeeList && _payeeList.beneficiaries) {
      const payeeList = _payeeList.beneficiaries;
      const payees = payeeList.filter((payee) => !payee.singleUse);
      const sortPayees = _.sortBy(
        payees,
        (payee) =>
          _.get(payee, 'display_name', '').toLowerCase() ||
          _.get(payee, 'to_account.name', '').toLowerCase()
      );
      return { beneficiaries: sortPayees };
    }
    return _payeeList;
  }
  getAccountDetail(id) {
    return _.find(_accountDetails, { id });
  }
  getSelectedAccount() {
    return _selectedFromAccount;
  }
  getSelectedToAccount() {
    return _selectedToAccount;
  }
  getSelectedPayee() {
    return _selectedPayee;
  }
  getSelectedPotData() {
    return _selectedPot;
  }
  enableFromContinue() {
    return enableFromContinue;
  }
  enableToContinue() {
    return enableToContinue;
  }

  getSelectedToPotData() {
    return _selectedToPot;
  }
  // Uses this function to get pop up for credit card
  getCreditPopUp() {
    if (_selectedFromAccount.type === StringConstant.credit_card) {
      return true;
    }
  }
  getSpendingFlag() {
    return isFromSpending;
  }
  isOnlyMoveMoney() {
    return _moveMoney;
  }
  /**
   * get the pot visibility for saving account transfer
   *
   * @return {Boolean}         True|false
   */
  setPotVisbility(toPot, savingId) {
    const fromPot = this.getSelectedPotData();
    let visible = false;
    if (fromPot !== undefined) {
      if (fromPot === StringConstant.EmptyString) {
        visible = true;
      }
      // visible one SA to same SA other pot
      if (
        this.getSelectedPot() !== toPot.id &&
        _selectedAccount.id === savingId
      ) {
        visible = true;
      }
      // visible if from is Not in pot and to all pot
      if (
        (fromPot.name === NotInPot || toPot.name === NotInPot) &&
        _selectedAccount.id !== savingId
      ) {
        visible = true;
      }
      if (
        _selectedAccount.type !== StringConstant.savings ||
        _isSavingTotClicked
      ) {
        visible = true;
      }
    }

    return visible;
  }
  // return true/false based on if pot data is empty or not
  checkPotEmpty(id) {
    const data = _.find(_potDetails, { id });
    if (data !== undefined) {
      if (data.pots.length !== 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
  // to return true or false in case of SavingTotClicked
  isSavingTotClicked() {
    if (_isSavingTotClicked) {
      if (_selectedAccount.id === _toSelectedAccount.id) {
        _selectedToPot = StringConstant.EmptyString;
      }
    }
    return _isSavingTotClicked;
  }

  /**
   * check whether to list saving account total click
   *
   * @return {Boolean}        true|false
   */
  isToSavingTotClicked() {
    return _isToSavingTotClicked;
  }

  IsAccountSame(id) {
    return id === _selectedAccount.id;
  }
  // to compare selected account in to list (mostly on click of cancel in cnfrm payment)
  IsToAccountSame(id) {
    if (_toSelectedAccount !== StringConstant.EmptyString) {
      return id === _toSelectedAccount.id;
    } else {
      return false;
    }
  }
  paymentType(data) {
    if (!data) {
      _selectedToPot = StringConstant.EmptyString;
      _toSelectedAccount = StringConstant.EmptyString;
      _endingDetails.reference = StringConstant.EmptyString;
      _isToSavingTotClicked = false;
      enableToContinue = false;
    } else {
      _selectedPayee = StringConstant.EmptyString;
    }

    _endingDetails.reference = StringConstant.EmptyString;
  }
  enablePayee() {
    if (_selectedFromAccount.actionsAvailable !== undefined) {
      if (
        _selectedFromAccount.actionsAvailable[
          '/account/payments/uk/default/out'
        ] === false
      ) {
        enablePayeeList = false;
      } else {
        enablePayeeList = true;
      }
    }
    return enablePayeeList;
  }

  enableToAccounts() {
    if (_selectedFromAccount.actionsAvailable !== undefined) {
      if (
        _selectedFromAccount.actionsAvailable[
          '/account/payments/transfer/out'
        ] === false
      ) {
        enableToAccountList = false;
      } else {
        enableToAccountList = true;
      }
    }
    if (this.getSpendingFlag()) {
      enableToAccountList = true;
    }
    return enableToAccountList;
  }
  setInReviewFlag(data) {
    _inReview = data;
    this.emitChange();
  }
  getReviewFlag() {
    return _inReview;
  }

  setFromAccountAmount(amount) {
    _fromAmount = amount;
  }

  getFromAccountAmount() {
    return _fromAmount;
  }

  getNextTask() {
    return _nextStep;
  }
  reset() {
    _accounts = [];
    _accountDetailIterator = 0;
    _successIterator = 0;
    _repeatData = {
      futureDate: moment(),
      reference: null,
      oneOffPayment: true,
      amount: '',
    };
  }
  getPaymentDetails(_isTransfer) {
    const paymentDetails = {};
    paymentDetails.accountId = _selectedFromAccount.id;
    paymentDetails.bankId = _selectedFromAccount.bank_id;

    if (_isTransfer) {
      paymentDetails.paymentType = StringConstant.transferUpper;
      const payeeDetails = {
        beneficiary_id: _selectedToAccount.id,
        display_name: _selectedToAccount.displayName,
        reference: _selectedToAccount.reference,
        account_number: _selectedToAccount.accountNumber,
        sort_code: _selectedToAccount.sortCode,
      };
      paymentDetails.payeeDetails = payeeDetails;
    } else {
      paymentDetails.paymentType = StringConstant.paymentUpper;
      const payeeDetails = {
        beneficiary_id: _selectedPayee.id,
        reference: _endingDetails.reference,
        account_number: _selectedPayee.to_account.account_number,
        display_name: _selectedPayee.display_name,
        sort_code: _selectedPayee.to_account.sort_code,
        to_account: _selectedPayee.to_account.name,
        isBiller: _selectedPayee.hasOwnProperty('biller_id'),
      };
      paymentDetails.payeeDetails = payeeDetails;
    }
    paymentDetails.amount = {
      value: parseFloat(_repeatData.amount),
      currency: 'GBP',
    };
    paymentDetails.details = _repeatData;
    if (_isTransfer) {
      if (
        !_.isEmpty(_selecctedPotOfFromAccount) &&
        _selectedFromAccount.id !== _selecctedPotOfFromAccount.id
      ) {
        paymentDetails.details.reference = _selecctedPotOfFromAccount.reference;
      }
      if (
        !_.isEmpty(_selecctedPotOfToAccount) &&
        _selectedToAccount.id !== _selecctedPotOfToAccount.id
      ) {
        paymentDetails.details.reference = _selecctedPotOfToAccount.reference;
      }
    }
    return paymentDetails;
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  // to return EndingDetails in case of repeat
  getEndingDetails() {
    return _endingDetails;
  }
  /**
   * return one-off payment object
   *
   * @return {Any}    	The corresponding value
   */
  getOneOffPayment() {
    return _spendingData;
  }

  /**
   * check whether payment is one-off payment
   *
   * @return {Boolean}    	true|false
   */
  isOneOffPayment() {
    return _spendingData !== StringConstant.EmptyString;
  }
  /**
   * check whether payment is one-off payment from repeat payment
   *
   * @return {Boolean}    	true|false
   */
  getResetOneOff() {
    return _resetToOneOff;
  }

  getToCredit() {
    return _toCredit;
  }
  isMakePayment() {
    let isPayment = true;
    // check from account
    if (_.isEmpty(_selectedAccount)) {
      isPayment = false;
    } else if (_.isEmpty(_toSelectedAccount) && _isTransfer === true) {
      // check to account
      isPayment = false;
    } else if (
      _selectedAccount.type !== StringConstant.savings &&
      _toSelectedAccount.type === StringConstant.savings &&
      _selectedToPot === StringConstant.EmptyString &&
      !_isToSavingTotClicked &&
      !this.checkPotEmpty(_toSelectedAccount.id)
    ) {
      isPayment = false;
    } else if (_.isEmpty(_selectedPayee) && _isTransfer === false) {
      isPayment = false;
    } else if (
      _selectedAccount.id === _toSelectedAccount.id &&
      _isTransfer === true
    ) {
      isPayment = false;
      if (this.isSameSavingSelectedPots()) {
        isPayment = true;
      }
    } else if (_endingDetails.isRepeat) {
      if (
        _endingDetails.end === StringConstant.EmptyString ||
        _endingDetails.dtStart === StringConstant.chooseDate ||
        _endingDetails.end === StringConstant.chooseDate ||
        _endingDetails.oftenText === StringConstant.pleaseSelect
      ) {
        isPayment = false;
      }
    } else if (
      _endingDetails.amount === StringConstant.EmptyString ||
      (_endingDetails.amount !== undefined &&
        parseFloat(_endingDetails.amount) <= 0)
    ) {
      isPayment = false;
    }
    if (this.getReferenceFlag() && _.isEmpty(_endingDetails.reference.trim())) {
      isPayment = false;
    }
    if (this.getToCredit()) {
      isPayment = true;
    }
    if (this.isSameSavingSelectedPots()) {
      isPayment = true;
    }

    return isPayment;
  }
  resetAfterEditPayment() {
    if (
      !_.isEmpty(_selectedFromAccount) &&
      !_selectedFromAccount.actionsAvailable['/account/payments/uk/default/out']
    ) {
      _selectedFromAccount = {};
    }
    _selectedToAccount = {};
  }
  resetAfterAddPayee() {
    _selectedToAccount = {};
    _repeatData.amount = '';
  }
  resetSelectedPayee() {
    _selectedPayee = StringConstant.EmptyString; // Why?!
  }
  resetPaymentData() {
    _nextStep = StringConstant.From;
    _selectedPayee = StringConstant.EmptyString;
    _selectedAccount = StringConstant.EmptyString;
    _toSelectedAccount = StringConstant.EmptyString;
    _selectedPot = StringConstant.EmptyString;
    _selectedToPot = StringConstant.EmptyString;
    _endingDetails.dtStart = StringConstant.chooseDate;
    _endingDetails.oftenText = StringConstant.chooseValue;
    _endingDetails.dtEndText = StringConstant.chooseDate;
    _endingDetails.stopitwhenText = StringConstant.whenicancel;
    _endingDetails.when = StringConstant.Today;
    _endingDetails.end = StringConstant.whenCancelText;
    _endingDetails.isRepeat = false;
    _endingDetails.amount = StringConstant.EmptyString;
    _endingDetails.reference = StringConstant.EmptyString;
    _endingDetails.oftenText = StringConstant.pleaseSelect;

    _response = null;
    isFromSpending = false;
    _isPotClick = false;
    _isSavingTotClicked = false;
    _fromSavingOpened = { id: '' };
    _toSavingOpened = { id: '' };
    _spendingData = StringConstant.EmptyString;
    _isToSavingTotClicked = false;
    _moveMoney = StringConstant.EmptyString;
    _endingDetails.isRegular = false;
    _endingDetails.isPickDateClicked = false;
    _endingDetails.isNoOfTimesClicked = false;
    _endingDetails.isWhenICancelClicked = true;
    _endingDetails.noOfTimesFlag = false;
    _endingDetails.pickDateFlag = false;
    _endingDetails.isRegular = false;
    _endingDetails.isOneOff = true;
    _resetToOneOff = false;
    enableFromContinue = false;
    enableToContinue = false;
    _selecctedPotOfFromAccount = {};
    _selectedFromAccount = {};
    _selecctedPotOfToAccount = {};
    _inReview = false;
    _displayManagePayeePage = false;
    _repeatData = {
      futureDate: moment(),
      reference: null,
      oneOffPayment: true,
      amount: '',
    };
    _selectedToAccount = {};
  }
  resetStoreForMakePayment() {
    _selecctedPotOfFromAccount = {};
    _selectedFromAccount = {};
    _selecctedPotOfToAccount = {};
    _inReview = false;
    _repeatData = {
      futureDate: moment(),
      reference: null,
      oneOffPayment: true,
      amount: '',
    };
    _response = null;
    _selectedToAccount = {};
    _selectedPayee = {};
    isFromSpending = false;
    _spendingData = StringConstant.EmptyString;
    _moveMoney = StringConstant.EmptyString;
  }
  resetStoreForResetPayment() {
    _selecctedPotOfFromAccount = {};
    _selectedFromAccount = {};
    _inReview = false;
    _response = null;
    _moveMoney = StringConstant.EmptyString;
  }
  resetPaymentDataAddPayee() {
    _nextStep = StringConstant.To;
    _selectedPayee = StringConstant.EmptyString;
    _toSelectedAccount = StringConstant.EmptyString;
    _selectedPot = StringConstant.EmptyString;
    _selectedToPot = StringConstant.EmptyString;
    _endingDetails.dtStart = StringConstant.chooseDate;
    _endingDetails.oftenText = StringConstant.chooseValue;
    _endingDetails.dtEndText = StringConstant.chooseDate;
    _endingDetails.stopitwhenText = StringConstant.whenicancel;
    _endingDetails.when = StringConstant.Today;
    _endingDetails.end = StringConstant.whenCancelText;
    _endingDetails.isRepeat = false;
    _endingDetails.amount = StringConstant.EmptyString;
    _endingDetails.reference = StringConstant.EmptyString;
    _endingDetails.oftenText = StringConstant.pleaseSelect;

    _response = null;
    isFromSpending = false;
    _isPotClick = false;
    _isSavingTotClicked = false;
    _fromSavingOpened = { id: '' };
    _toSavingOpened = { id: '' };
    _spendingData = StringConstant.EmptyString;
    _isToSavingTotClicked = false;
    _moveMoney = StringConstant.EmptyString;
    _endingDetails.isRegular = false;
    _endingDetails.isPickDateClicked = false;
    _endingDetails.isNoOfTimesClicked = false;
    _endingDetails.isWhenICancelClicked = true;
    _endingDetails.noOfTimesFlag = false;
    _endingDetails.pickDateFlag = false;
    _endingDetails.isRegular = false;
    _resetToOneOff = false;
    enableFromContinue = false;
    enableToContinue = false;
  }

  resetRepeatPaymentData() {
    _endingDetails = {
      dtStart: StringConstant.chooseDate,
      dtEndText: StringConstant.chooseDate,
      oftenText: StringConstant.pleaseSelect,
      stopitwhenText: StringConstant.whenicancel,
      when: StringConstant.Today,
      end: StringConstant.whenCancelText,
      isRepeat: false,
      endingText: StringConstant.EmptyString,
      reference: StringConstant.EmptyString,
      amount: StringConstant.EmptyString,
      endDate: StringConstant.chooseDate,
      isOneOff: true,
      isPickDateClicked: false,
      isNoOfTimesClicked: false,
      isWhenICancelClicked: true,
      noOfTimesFlag: false,
      pickDateFlag: false,
      isRegular: false,
    };
  }
  getMakePaymentResponse() {
    return _response;
  }
  getVerificationType() {
    return _.get(_response, 'error.verification_type', '');
  }

  refreshPaymentResponse() {
    _response = null;
  }
  // returns true/false to use as flag for reference in rp
  getReferenceFlag() {
    let isrefShown = true;
    if (_isTransfer) {
      if (
        _selectedPot.id === _selectedAccount.id ||
        (_toSelectedAccount !== StringConstant.EmptyString &&
          _selectedToPot !== undefined &&
          _selectedToPot.id === _toSelectedAccount.id)
      ) {
        isrefShown = true;
        if (
          (_selectedPot !== StringConstant.EmptyString &&
            _selectedPot.id !== _selectedAccount.id) ||
          (_selectedToPot !== StringConstant.EmptyString &&
            _selectedToPot.id !== _toSelectedAccount.id)
        ) {
          isrefShown = false;
        }
      } else {
        if (_selectedPot === StringConstant.EmptyString) {
          isrefShown = true;
        }

        if (_selectedPot !== StringConstant.EmptyString) {
          if (
            _selectedPot.name === NotInPot &&
            _selectedToPot === StringConstant.EmptyString
          ) {
            isrefShown = true;
          } else {
            isrefShown = false;
          }
        }
        if (
          _selectedToPot !== StringConstant.EmptyString &&
          _selectedPot.name !== NotInPot
        ) {
          isrefShown = false;
        }
      }
    } else {
      if (_selectedPot.id === _selectedAccount.id) {
        isrefShown = true;
      } else if (
        _selectedPot === StringConstant.EmptyString &&
        _selectedToPot === StringConstant.EmptyString
      ) {
        isrefShown = true;
      }
    }

    return isrefShown;
  }
  // returns amount
  getRepeatAmount() {
    return _endingDetails.amount === StringConstant.EmptyString
      ? this.getDefaultAmt()
      : _endingDetails.amount;
  }
  // to return £
  getDefaultAmt() {
    return '';
  }
  // returns _isTransfer to check payment type
  getPaymentType() {
    return _isTransfer;
  }
  //  to return true or false for in case of same pot
  IsPotSame(id) {
    return (
      id ===
      (_.isEmpty(_selectedPot) ? StringConstant.EmptyString : _selectedPot.id)
    );
  }
  //  to return true or false for in case of same to pot
  isToPotSame(id) {
    return (
      id ===
      (_.isEmpty(_selectedToPot)
        ? StringConstant.EmptyString
        : _selectedToPot.id)
    );
  }
  // to return true or false in case of PotClick
  isPotClicked() {
    return _isPotClick;
  }
  // returns true or StringConstant.EmptyString to show repeat payment
  repeatPaymentShow(account) {
    const selAccount = account === undefined ? _selectedAccount : account;
    if (_selectedPayee.hasOwnProperty('biller_id')) {
      return false;
    }
    if (selAccount !== StringConstant.EmptyString) {
      if (selAccount.actionsAvailable['/account/mandates/so/write'] === true) {
        return true;
      }
    } else {
      return false;
    }
  }

  // To check if both Pots selected
  isSameSavingSelectedPots() {
    let isSame = false;

    if (
      _selectedPot !== StringConstant.EmptyString &&
      _selectedToPot !== StringConstant.EmptyString &&
      _selectedAccount.id === _toSelectedAccount.id
    ) {
      isSame = true;
      if (
        _endingDetails.amount === StringConstant.EmptyString ||
        (_endingDetails.amount !== undefined &&
          parseFloat(_endingDetails.amount) <= 0)
      ) {
        isSame = false;
      }
    }
    if (this.isOneOffPayment() && !this.getOneOffPayment().isMonthly) {
      isSame = true;
    }
    if (this.getToCredit()) {
      isSame = true;
    }
    return isSame;
  }
  // to return true or false for selected pot
  getSelectedPotId() {
    return _.isEmpty(_selecctedPotOfFromAccount)
      ? StringConstant.EmptyString
      : _selecctedPotOfFromAccount.id;
  }
  // to return true or false for selected to pot
  getSelectedToPotId() {
    return _.isEmpty(_selecctedPotOfToAccount)
      ? StringConstant.EmptyString
      : _selecctedPotOfToAccount.id;
  }

  isFromSavingOpen(accountId) {
    return accountId === _fromSavingOpened.id;
  }

  setFromSavingOpened(accountId) {
    _fromSavingOpened.id = accountId;
    this.emitChange();
  }
  isToSavingOpen(accountId) {
    return accountId === _toSavingOpened.id;
  }
  setToSavingOpened(accountId) {
    _toSavingOpened.id = accountId;
    this.emitChange();
  }

  getTempSelectedToPot() {
    return _tempSelectedToPot;
  }
  getTempSelectedPot() {
    return _tempSelectedPot;
  }
  isParentClick() {
    return _isParentClick;
  }
  setParentClick(status, type) {
    _isParentClick = {
      status,
      type,
    };
  }

  setSelectedFromAccount(account) {
    _selectedFromAccount = account;
  }
  getSelectedFromAccount() {
    return _selectedFromAccount;
  }
  setSelectedPotOfFromAccount(potData) {
    _selecctedPotOfFromAccount = potData;
  }
  getSelectedPotOfFromAccount(accountId) {
    return _selectedFromAccount.id === accountId
      ? _selecctedPotOfFromAccount
      : {};
  }

  setSelectedToAccount(account) {
    _selectedPayee = '';
    _selectedToAccount = account;
  }
  setSelectedPotOfToAccount(potData) {
    _selecctedPotOfToAccount = potData;
  }
  getSelectedPotOfToAccount(accountId) {
    return _selectedToAccount.id === accountId ? _selecctedPotOfToAccount : {};
  }
  // for pot details
  getSelectedToPot() {
    return _selecctedPotOfToAccount;
  }
  getSelectedFromPot() {
    return _selecctedPotOfFromAccount;
  }

  resetStore() {
    _repeatData = {
      futureDate: moment(),
      reference: null,
      oneOffPayment: true,
      amount: '',
    };
    enableToAccountList = true;
    enablePayeeList = true;
    _fromAmount = 0;
    _accounts = [];
    _accountDetailIterator = 0;
    _successIterator = 0;
    _selectedAccount = StringConstant.EmptyString;
    _toSelectedAccount = StringConstant.EmptyString;
    _selectedPayee = StringConstant.EmptyString;
    _nextStep = StringConstant.From;
    _selectedPot = StringConstant.EmptyString;
    _selectedToPot = StringConstant.EmptyString;
    _tempSelectedPot = StringConstant.EmptyString;
    _tempSelectedToPot = StringConstant.EmptyString;
    _isPotClick = false;
    _isTransfer = false;
    _isSavingTotClicked = false;
    _fromSavingOpened = { id: '' };
    _toSavingOpened = { id: '' };
    _accountDetails = [];
    accountList = [];
    _potDetails = [];
    _payeeList = [];
    _moveMoney = StringConstant.EmptyString;
    _spendingData = StringConstant.EmptyString;
    isFromSpending = false;
    _isToSavingTotClicked = false;
    enableToContinue = false;
    enableFromContinue = false;
    _toCredit = false;
    _displayManagePayeePage = false;
    _endingDetails = {
      dtStart: StringConstant.chooseDate,
      dtEndText: StringConstant.chooseDate,
      oftenText: StringConstant.pleaseSelect,
      stopitwhenText: StringConstant.whenicancel,
      when: moment(),
      end: StringConstant.whenCancelText,
      isRepeat: false,
      endingText: StringConstant.EmptyString,
      reference: StringConstant.EmptyString,
      amount: StringConstant.EmptyString,
      endDate: StringConstant.chooseDate,
      isOneOff: true,
      isPickDateClicked: false,
      isNoOfTimesClicked: false,
      isWhenICancelClicked: true,
      noOfTimesFlag: false,
      pickDateFlag: false,
      isRegular: false,
    };
    _response = null;
    _resetToOneOff = false;
    _isParentClick = {
      status: false,
      type: '',
    };
    _selecctedPotOfFromAccount = {};
    _selectedFromAccount = {};
    _selecctedPotOfToAccount = {};
    _selectedToAccount = {};
    _repeatData = {
      futureDate: moment(),
      reference: null,
      oneOffPayment: true,
      amount: '',
    };
  }
  // update payee list on Add Payee Success
  updatePayeeList(payeeDetail) {
    const payeeDetails = payeeDetail;
    _payeeList.beneficiaries.push(payeeDetails);
  }
  updateSinglePayee(id, updatedDetails) {
    _payeeList.beneficiaries = _payeeList.beneficiaries.map((payee) => {
      if (payee.id !== id) {
        return payee;
      }

      return { ...payee, ...updatedDetails };
    });
  }
  deletePayeeFromList(beneficiaryId) {
    _.remove(_payeeList.beneficiaries, (payee) => payee.id === beneficiaryId);
  }
  setSelectedPayee(payeeDetail) {
    _selectedPayee = payeeDetail;
    _endingDetails.reference = _selectedPayee.reference;
    if (MoveMoneyPayeeStore.getEditPayeeFlag() && _selectedAccount === '') {
      _nextStep = StringConstant.To;
    } else {
      _nextStep = StringConstant.RP;
    }
    this.emitChange();
  }

  getSavingsPotToClicked(sentToAccountID) {
    return (
      _isSavingsPotToClicked && sentToAccountID === _selectedToPotAccountID
    );
  }
  getBackUrl() {
    return backURL;
  }
  resetSavingsPotToClicked(flag) {
    _isSavingsPotToClicked = flag;
    this.emitChange();
  }
  getSavingsPotFromClicked(sentAccountID) {
    return _isSavingsPotFromClicked && sentAccountID === _selectedPotAccountID;
  }
  resetSavingsPotFromClicked(flag) {
    _isSavingsPotFromClicked = flag;
    this.emitChange();
  }
  getPayeeListError() {
    return payeeListError;
  }
  makePaymentToThisPayee() {
    _isTransfer = false;
    this.emitChange();
  }
  callIsUpdateBalance(value) {
    isUpdateBalance = value;
  }
  returnIsUpdateBalance() {
    return isUpdateBalance;
  }

  setDisplayManagePayeePage(val) {
    _displayManagePayeePage = val;
  }

  isDisplayManagePayeePage() {
    return _displayManagePayeePage;
  }
  getPayeeByAccountNumberSortCode(accountNumber, sortCode) {
    return getPayee(_payeeList, accountNumber, sortCode);
  }
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action.data;

    switch (actionType) {
      case MoveMoneyConstants.GET_FROM_ACCOUNTS:
        _accountDetails = [];
        MoveMoneyApiUtils.getAccountsList();
        break;
      case MoveMoneyConstants.GET_FROM_ACCOUNTS_SUCCESS:
        accountList = actionData;
        break;
      case MoveMoneyConstants.REQUEST_ACCOUNTS_LIST:
        break;
      case MoveMoneyConstants.SET_MOVEMONEY_BACK_URL:
        backURL = actionData;
        break;
      case MoveMoneyConstants.REQUEST_ACCOUNTS_LIST_SUCCESS:
        _accounts = actionData;
        const _potAccounts = this.getFromAccountsFromAccountsStore();
        _potAccounts.map((account) => {
          if (account.actionsAvailable['/account/pots']) {
            MoveMoneyApiUtils.getPotDetails(account.id);
          }
          return false;
        });
        break;
      case MoveMoneyConstants.REQUEST_ACCOUNT_DETAIL:
        MoveMoneyApiUtils.getAccountDetails(actionData);
        break;
      case MoveMoneyConstants.REQUEST_ACCOUNT_DETAIL_SUCCESS:
        if (actionData.code === 401) {
          const index = _.findIndex(_accountDetails, ['id', actionData.id]);
          if (index >= 0) {
            _accountDetails.splice(index, 1);
          }
          _accountDetails.push(actionData);
        } else {
          const error = {
            id: MoveMoneyStore.id,
            errCode: MoveMoneyStore.errCode,
          };
          _accountDetails.push(error);
        }
        if (_accountDetails.length === accountList.length) {
          this.emitChange();
        }
        break;

      case MoveMoneyConstants.REQUEST_POT_DETAILS:
        MoveMoneyApiUtils.getPotDetails(actionData);
        break;

      case MoveMoneyConstants.REQUEST_POT_DETAIL_SUCCESSS:
        const index1 = _.findIndex(_potDetails, { id: actionData.id });
        if (index1 >= 0) {
          _potDetails.splice(index1, 1, actionData);
        } else {
          _potDetails.push(actionData);
        } // add not in pot
        const savPot = _.find(_potDetails, { id: actionData.id });
        if (actionData.pots.length !== 0) {
          const pot = {
            id: actionData.id,
            name: NotInPot,
            reference: StringConstant.EmptyString,
            balance: actionData.unAllocatedData,
          };
          savPot.pots.push(pot);
        }
        this.emitChange();
        break;
      case MoveMoneyConstants.GET_FROM_PAYEES_MOVEMONEY:
        payeeListError = '';
        MoveMoneyApiUtils.getPayeeList();
        break;

      case MoveMoneyConstants.SAVING_TOT_CLICKED:
        _selectedPot = StringConstant.EmptyString;
        _isSavingTotClicked = actionData;
        enableFromContinue = true;
        _tempSelectedPot = StringConstant.EmptyString;
        _isPotClick = false;
        this.emitChange();
        break;
      case MoveMoneyConstants.SAVING_TO_TOT_CLICK:
        _isToSavingTotClicked = actionData;
        _selectedToPot = StringConstant.EmptyString;
        _tempSelectedToPot = StringConstant.EmptyString;
        enableToContinue = true;
        _isPotClick = false;
        if (_isTransfer) {
          _endingDetails.reference = StringConstant.EmptyString;
        }

        this.emitChange();
        break;

      case MoveMoneyConstants.GET_FROM_PAYEES_SUCCESS_MOVEMONEY:
        payeeListError = '';
        _payeeList = actionData;
        this.getFromAccountsFromAccountsStore().forEach((potAccount) => {
          if (potAccount.actionsAvailable['/account/pots']) {
            MoveMoneyApiUtils.getPotDetails(potAccount.id);
          }
        });
        this.emitChange();

        break;
      case MoveMoneyConstants.GET_FROM_PAYEES_FAILURE:
        payeeListError = actionData;
        _payeeList = {
          beneficiaries: [],
        };
        this.emitChange();
        break;

      case MoveMoneyConstants.SELECT_PAYEEE:
        this.resetRepeatPaymentData();
        _isTransfer = false;
        _selectedToAccount = {};
        this.paymentType(_isTransfer);
        _selectedPayee = actionData;
        _toCredit = false;
        _endingDetails.amount = StringConstant.EmptyString;
        _toSelectedAccount = StringConstant.EmptyString;
        _endingDetails.reference = _selectedPayee.reference;
        if (_nextStep === StringConstant.To) {
          _nextStep = StringConstant.RP;
        }
        this.emitChange();
        break;
      case MoveMoneyConstants.PUT_SELECTED_ACCOUNT:
        if (!this.getSpendingFlag()) {
          this.resetRepeatPaymentData();
        }
        if (actionData.type !== StringConstant.savings) {
          _selectedPot = StringConstant.EmptyString;
          _isSavingTotClicked = false;
          enableFromContinue = false;
          if (_nextStep === StringConstant.From) {
            _nextStep = StringConstant.To;
          }
          if (_nextStep === StringConstant.To && this.getSpendingFlag()) {
            _nextStep = StringConstant.KP;
          }
          if (
            _nextStep === StringConstant.To &&
            MoveMoneyPayeeStore.getEditPayeeFlag()
          ) {
            _nextStep = StringConstant.KP;
          }
          if (_isTransfer) {
            if (actionData.id === _toSelectedAccount.id) {
              _toSelectedAccount = StringConstant.EmptyString;
              _nextStep = StringConstant.To;
            }
          }
        } else {
          _selectedAccount = actionData;
          if (_isTransfer) {
            if (
              (_nextStep === StringConstant.KP ||
                _nextStep === StringConstant.RP) &&
              actionData.id === _toSelectedAccount.id &&
              _selectedPot.id === _selectedToPot.id
            ) {
              _toSelectedAccount = StringConstant.EmptyString;
              _selectedToPot = StringConstant.EmptyString;
              _nextStep = StringConstant.To;
            }
          }
          if (
            !this.getSpendingFlag() &&
            _selectedPot.name !== 'Not in Pot' &&
            !_isSavingTotClicked
          ) {
            _selectedToPot = StringConstant.EmptyString;
          }
          enableFromContinue = false;
          if (
            this.checkPotEmpty(actionData.id) === true &&
            actionData.type !== 'current'
          ) {
            _selectedPot = StringConstant.EmptyString;
            _isSavingTotClicked = true;
          }
          if (
            _nextStep === StringConstant.From &&
            (_isPotClick || _isSavingTotClicked)
          ) {
            _nextStep = StringConstant.To;
          }
          if (_nextStep === StringConstant.To && this.getSpendingFlag()) {
            _nextStep = StringConstant.KP;
          }
        }

        if (_selectedAccount.id !== actionData.id) {
          _isSavingTotClicked = false;

          _selectedPot = StringConstant.EmptyString;
        }

        if (_selectedToPot !== undefined && _selectedPot !== undefined) {
          if (
            (_selectedToPot.name === NotInPot &&
              _selectedPot.name === NotInPot &&
              _selectedAccount.id === _toSelectedAccount.id) ||
            (_selectedPot !== StringConstant.EmptyString &&
              _selectedToPot.id === _selectedPot.id)
          ) {
            _selectedToPot = StringConstant.EmptyString;
          }
        }

        if (
          actionData.actionsAvailable['/account/payments/uk/default/out'] ===
            false &&
          !_.isEmpty(_selectedPayee)
        ) {
          _selectedPayee = StringConstant.EmptyString;
          _endingDetails.reference = StringConstant.EmptyString;
          _nextStep = StringConstant.To;
        }
        if (
          actionData.actionsAvailable['/account/payments/transfer/out'] ===
          false
        ) {
          _toSelectedAccount = StringConstant.EmptyString;
          _selectedToPot = StringConstant.EmptyString;
          if (_nextStep === StringConstant.From) {
            _nextStep = StringConstant.To;
          }
        }

        _selectedAccount = actionData;
        this.emitChange();
        break;
      case MoveMoneyConstants.SET_ENDING_DETAILS:
        let isEmit = true;
        switch (actionData.type) {
          case StringConstant.stop:
            _endingDetails.end = StringConstant.EmptyString;
            _endingDetails.stopitwhenText = StringConstant.EmptyString;
            _endingDetails.stopitwhenText = actionData.value;
            if (_endingDetails.stopitwhenText === StringConstant.whenicancel) {
              _endingDetails.end = StringConstant.whenCancelText;
              _endingDetails.isPickDateClicked = false;
              _endingDetails.isNoOfTimesClicked = false;
              _endingDetails.isWhenICancelClicked = true;
              _endingDetails.pickDateFlag = false;
              _endingDetails.noOfTimesFlag = false;
            }
            if (_endingDetails.stopitwhenText === StringConstant.Pickadate) {
              _endingDetails.end = StringConstant.chooseDate;
              _endingDetails.isPickDateClicked = true;
              _endingDetails.isNoOfTimesClicked = false;
              _endingDetails.isWhenICancelClicked = false;
              _endingDetails.pickDateFlag = true;
              _endingDetails.noOfTimesFlag = false;
            }
            if (_endingDetails.stopitwhenText === StringConstant.Nooftimes) {
              _endingDetails.isPickDateClicked = false;
              _endingDetails.isNoOfTimesClicked = true;
              _endingDetails.isWhenICancelClicked = false;
              _endingDetails.noOfTimesFlag = true;
              _endingDetails.pickDateFlag = false;
            }
            break;
          case StringConstant.setSelOften:
            _endingDetails.oftenText = actionData.value;
            break;
          case StringConstant.dtStart:
            _endingDetails.dtStart = actionData.value;
            break;
          case StringConstant.end:
            _endingDetails.end = actionData.value;
            break;
          case StringConstant.amt:
            _endingDetails.amount = actionData.value;
            _nextStep = StringConstant.RP;
            isEmit = true;
            break;
          case StringConstant.isRepeat:
            _endingDetails.isRepeat = actionData.value;
            break;
          case StringConstant.noOfTimes:
            _endingDetails.noOfTimes = actionData.value;
            break;
          case StringConstant.dtWhen:
            _endingDetails.when = actionData.value;
            break;
          case StringConstant.repeatClicked:
            _endingDetails.isRepeat = actionData.value;
            _endingDetails.isOneOff = false;
            break;
          case StringConstant.oneOffClicked:
            _endingDetails.isOneOff = actionData.value;
            _endingDetails.isRepeat = false;
            break;
          case StringConstant.reference:
            _endingDetails.reference = actionData.value;
            isEmit = true;
            break;
          default: {
            break;
          }
        }
        if (isEmit) {
          this.emitChange();
        }
        break;
      case MoveMoneyConstants.PUT_TO_SELECTED_ACCOUNT:
        this.resetRepeatPaymentData();
        _isTransfer = true;
        _endingDetails.amount = StringConstant.EmptyString;
        this.paymentType(_isTransfer);
        if (
          actionData.type === 'savings' &&
          _toSelectedAccount !== StringConstant.EmptyString &&
          _toSelectedAccount.id !== actionData.id &&
          this.isToSavingTotClicked()
        ) {
          _selectedToPot = StringConstant.EmptyString;
          _isToSavingTotClicked = false;
          enableToContinue = false;
          _isPotClick = false;
        }
        if (
          actionData.type !== 'savings' &&
          _toSelectedAccount !== StringConstant.EmptyString &&
          _toSelectedAccount.id !== actionData.id
        ) {
          _selectedToPot = StringConstant.EmptyString;
          _isToSavingTotClicked = false;
          enableToContinue = false;
          _isPotClick = false;
        }
        if (_isTransfer) {
          _endingDetails.reference = StringConstant.EmptyString;
        }
        if (actionData.type === 'credit_card') {
          _toCredit = true;
        } else {
          _toCredit = false;
        }
        _toSelectedAccount = actionData;
        _selectedPayee = StringConstant.EmptyString;

        if (
          this.checkPotEmpty(actionData.id) === true &&
          actionData.type !== 'current'
        ) {
          _selectedToPot = StringConstant.EmptyString;
          _isToSavingTotClicked = true;
        }

        if (_nextStep === StringConstant.To) {
          _nextStep = StringConstant.KP;
        }

        if (
          _nextStep === StringConstant.To &&
          _selectedAccount !== StringConstant.EmptyString
        ) {
          if (
            _toSelectedAccount.type !== StringConstant.savings ||
            _.isEmpty(_selectedToPot) === false
          ) {
            _nextStep = StringConstant.RP;
          }
        }
        this.emitChange();
        break;
      case MoveMoneyConstants.POST_TO_STORE:
        if (!this.repeatPaymentShow()) {
          _endingDetails.isRepeat = false;
        }
        _nextStep = StringConstant.CNFRM;
        this.emitChange();
        break;
      case MoveMoneyConstants.GO_BACK_TO_RP:
        _nextStep = actionData;
        _response = null;
        this.emitChange();
        break;
      case MoveMoneyConstants.MAKE_DD_MOVEMONEY_SERVICECALL:
        _nextStep = 'THNK';
        MoveMoneyApiUtils.makeDDPayment(actionData);
        break;
      case MoveMoneyConstants.MAKE_PAYMENT_SUCCESS:
        _nextStep = 'THNK';
        _response = actionData;
        this.emitChange();
        break;
      case MoveMoneyConstants.MAKE_PAYMENT_FAILURE:
        _nextStep = StringConstant.CNFRM;
        _response = actionData;
        this.emitChange();
        break;
      case MoveMoneyConstants.MAKE_SO_MOVEMONEY_SERVICECALL:
        _nextStep = 'THNK';
        MoveMoneyApiUtils.makeSOPayment(actionData);
        break;
      case MoveMoneyConstants.SELECTED_MoveMoneyPOT:
        _tempSelectedPot = actionData.potData;
        _selectedPotAccountID = actionData.selectedPotAccountID;
        _isSavingsPotFromClicked = true;
        _isSavingTotClicked = false;
        enableFromContinue = false;
        this.emitChange();
        break;
      case MoveMoneyConstants.CONTINUE_POT_CLICKED:
        _selectedPot = _tempSelectedPot;
        _endingDetails.isRepeat = false;
        this.emitChange();
        break;
      case MoveMoneyConstants.MoveMoneyPOT_CLICKED:
        _isPotClick = actionData;
        break;
      case MoveMoneyConstants.SELECTED_TO_MoveMoneyPOT:
        _tempSelectedToPot = actionData.toPotData;
        _selectedToPotAccountID = actionData.selectedToPotAccountID;
        _isSavingsPotToClicked = true;
        _isToSavingTotClicked = false;
        enableToContinue = false;
        this.emitChange();
        break;
      case MoveMoneyConstants.CONTINUE_TO_POT_CLICKED:
        _selectedToPot = _tempSelectedToPot;
        _endingDetails.reference = _selectedToPot.reference;
        this.emitChange();
        break;
      case MoveMoneyConstants.CREATE_SINGLE_USE_PAYEE_SERVICECALL_MOVEMONEY:
        _nextStep = 'THNK';
        MoveMoneyApiUtils.makeSingleUsePayee(actionData);
        break;
      case MoveMoneyConstants.MAKE_INTER_POT_TRASNFER_SERVICECALL_MOVEMONEY:
        _nextStep = 'THNK';
        MoveMoneyApiUtils.makeInterPotTransfer(actionData);
        break;
      case MoveMoneyConstants.SPENDING_MOVE_MONEY:
        const spendingData = actionData;
        _moveMoney = spendingData;
        _isTransfer = true;
        isFromSpending = true;
        if (spendingData !== undefined) {
          _toSelectedAccount = _.find(AccountsStore.getAll(), {
            id: spendingData.id,
          });
          _selectedToAccount = _toSelectedAccount;
          _nextStep = StringConstant.To;
          _isToSavingTotClicked = true;
          _selectedToPot = StringConstant.EmptyString;
          if (spendingData.potId !== undefined) {
            _isToSavingTotClicked = false;
            const selectedPotAcc = this.getPotDetails(spendingData.id);
            if (selectedPotAcc !== undefined) {
              // set selected pot for account
              if (selectedPotAcc.pots.length > 0) {
                _selectedToPot = _.find(selectedPotAcc.pots, {
                  id: spendingData.potId,
                });
                _selecctedPotOfToAccount = _selectedToPot;
                _isPotClick = true;
                // set account selected if pot value is negative
                if (selectedPotAcc.unAllocatedData < 0) {
                  _isToSavingTotClicked = true;
                  _isPotClick = false;
                }
              } else {
                _selectedToPot = spendingData.potId;
                _selecctedPotOfToAccount = spendingData.potId;
              }
            }
          }
        }

        this.emitChange();
        break;
      // need to change
      case MoveMoneyConstants.SPENDING_TRANSFER_MONEY:
        /**
         * Warning - DP (CX-10232):
         * This was always faulty due to the:
         *  - typo in the method name `resetPaymentDatas`
         *  - wrong logic in its action creator - MoveMoneyActionCreator.spendingTransferMoney
         *  - direct state mutations in `RepeatPayment_Refactor` component
         *
         * This snippet is now disabled to prevent additional confusion.
         *
         * @code:
         *  // reset payment data if one-off payment requested from payment thank you page
         *  if (actionData.fromPayment !== undefined) {
         *    this.resetPaymentDatas();
         *  }
         */

        _spendingData = actionData;
        _isTransfer = true;
        isFromSpending = true;
        _selectedToAccount = _.find(AccountsStore.getAll(), {
          id: _spendingData.id,
        });
        // check if pot id pass for transfer
        if (_spendingData.potId) {
          const selectedPotAcc = this.getPotDetails(_spendingData.id);
          if (selectedPotAcc) {
            // set selected pot for account
            if (selectedPotAcc.pots.length > 0) {
              _selectedToPot = _.find(selectedPotAcc.pots, {
                id: _spendingData.potId,
              });
              _selecctedPotOfToAccount = _selectedToPot;
              // set account selected if pot value is negative
              if (selectedPotAcc.unAllocatedData < 0) {
                _isSavingTotClicked = true;
              }
            } else {
              _selectedToPot = _spendingData.id;
              _selecctedPotOfToAccount = _spendingData.id;
            }
            _isPotClick = true;
          }
        } else {
          // in case of transfer to saving account
          _isSavingTotClicked = true;
        }
        // && !_spendingData.isMonthly
        if (_spendingData.amt > 0) {
          _repeatData.amount = _spendingData.amt;
        }
        if (_spendingData.isMonthly) {
          _repeatData.oneOffPayment = false;
          _repeatData.amount = _spendingData.amt2;
        }

        this.emitChange();
        break;

      case AppConstants.RESET_DATA:
        this.resetPaymentData();
        break;
      case AppConstants.LOGOUT_USER:
        this.resetStore();
        this.emitChange();
        break;
      default:
    }
  }
}
export default new MoveMoneyStore();
